$(window).scroll(function () {
var scroll = $(window).scrollTop();
if (scroll < 200) {
$('.fixed-top').css({
"background": "#fff0",
"box-shadow": "none"
});
} else {
$('.fixed-top').css({
"background": "#d32141",
"box-shadow": "9px 11px 31px -1px rgb(0 0 0 / 60%)"

});
}
});

var owl = $('.hamp_pr_slider');
owl.owlCarousel({
loop:true,
margin:8,
nav:true,
dots:true,
navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
autoplay: 3000,
smartSpeed: 1000,
stagepadding:20,
responsive:{
0:{
items:2
},
600:{
items:2
},
1000:{
items:4
}
}
});  



$(document).ready(function() {
$(document).scroll(function() {
if ($(document).scrollTop() >= 25) {
$('.hd_log').addClass('js-scrolling');
} else {
$('.hd_log').removeClass('js-scrolling');
}
});
});   



(() => {
        
    const openNavMenu = document.querySelector(".open-nav-menu"),
       closeNavMenu = document.querySelector(".close-nav-menu"),
       navMenu = document.querySelector(".nav-menu"),
       menuOverlay = document.querySelector(".menu-overlay"),
       mediaSize = 991;
 
    openNavMenu.addEventListener("click", toggleNav);
    closeNavMenu.addEventListener("click", toggleNav);
    // close the navMenu by clicking outside
    menuOverlay.addEventListener("click", toggleNav);
 
    function toggleNav() {
       navMenu.classList.toggle("open");
       menuOverlay.classList.toggle("active");
       document.body.classList.toggle("hidden-scrolling");
    }
 
    navMenu.addEventListener("click", (event) => {
       if (event.target.hasAttribute("data-toggle") &&
          window.innerWidth <= mediaSize) {
          // prevent default anchor click behavior
          event.preventDefault();
          const menuItemHasChildren = event.target.parentElement;
          // if menuItemHasChildren is already expanded, collapse it
          if (menuItemHasChildren.classList.contains("active")) {
             collapseSubMenu();
          } else {
             // collapse existing expanded menuItemHasChildren
             if (navMenu.querySelector(".menu-item-has-children.active")) {
                collapseSubMenu();
             }
             // expand new menuItemHasChildren
             menuItemHasChildren.classList.add("active");
             const subMenu = menuItemHasChildren.querySelector(".sub-menu");
             subMenu.style.maxHeight = subMenu.scrollHeight + "px";
          }
       }
    });
 
    function collapseSubMenu() {
       navMenu.querySelector(".menu-item-has-children.active .sub-menu")
          .removeAttribute("style");
       navMenu.querySelector(".menu-item-has-children.active")
          .classList.remove("active");
    }
 
    function resizeFix() {
       // if navMenu is open ,close it
       if (navMenu.classList.contains("open")) {
          toggleNav();
       }
       // if menuItemHasChildren is expanded , collapse it
       if (navMenu.querySelector(".menu-item-has-children.active")) {
          collapseSubMenu();
       }
    }
 
    window.addEventListener("resize", function () {
       if (this.innerWidth > mediaSize) {
          resizeFix();
       }
    });
 
 })();


 (function ($) {	

	$.fn.searchBox = function(ev) {

		var $searchEl = $('.search-elem');
		var $placeHolder = $('.placeholder');
		var $sField = $('#search-field');

		if ( ev === "open") {
			$searchEl.addClass('search-open')
		};

		if ( ev === 'close') {
			$searchEl.removeClass('search-open'),
			$placeHolder.removeClass('move-up'),
			$sField.val(''); 
		};

		var moveText = function() {
			$placeHolder.addClass('move-up');
		}

		$sField.focus(moveText);
		$placeHolder.on('click', moveText);
		
		$('.submit').prop('disabled', true);
		$('#search-field').keyup(function() {
	        if($(this).val() != '') {
	           $('.submit').prop('disabled', false);
	        }
	    });
	}	

}(jQuery));

$('.search-btn').on('click', function(e) {
	$(this).searchBox('open');
	e.preventDefault();
});

$('.close').on('click', function() {
	$(this).searchBox('close');
});


$('#play-video1').on('click', function(e){
   e.preventDefault();
   $('#video-overlay1').addClass('open');
   $("#video-overlay1").append('<iframe width="560" height="315" src="https://www.youtube.com/embed/ngElkyQ6Rhs" frameborder="0" allowfullscreen></iframe>');
 });
$('#play-video2').on('click', function(e){
e.preventDefault();
$('#video-overlay1').addClass('open');
$("#video-overlay1").append('<iframe width="560" height="315" src="https://www.youtube.com/embed/ngElkyQ6Rhs" frameborder="0" allowfullscreen></iframe>');
});

 $('.video-overlay, .video-overlay-close').on('click', function(e){
   e.preventDefault();
   close_video();
 });
 
 $(document).keyup(function(e){
   if(e.keyCode === 27) { close_video(); }
 });
 
 function close_video() {
   $('.video-overlay.open').removeClass('open').find('iframe').remove();
 };





 